import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { SendTypesUi } from 'src/app/configs/send-type-ui.config';
import { SendTypes } from 'src/app/core/api/models';


@Directive({
  selector: '[sendTypeIconLarge]',
  standalone: true
})
export class SendTypeIconLargeDirective implements OnInit {

  @Input("sendTypeIconLarge") type: SendTypes;

  constructor(private element: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {

    let classList = "tw-text-sm mdi-32px tw-font-bold tw-mx-2 tw-text-";
    switch (this.type) {
      case SendTypes.ApiP2P:
        classList += this.getColor(SendTypes.ApiP2P) + " dark:!tw-text-" + this.getColor(SendTypes.ApiP2P) + " " +  this.getIcon(SendTypes.ApiP2P);
        break;
      case SendTypes.ApiSingle:
        classList += this.getColor(SendTypes.ApiSingle) + " dark:!tw-color-" + this.getColor(SendTypes.ApiSingle) + " " +  this.getIcon(SendTypes.ApiSingle);
        break;
      case SendTypes.Bulk:
        classList += this.getColor(SendTypes.Bulk) + " dark:!tw-text-" + this.getColor(SendTypes.Bulk) + " " +  this.getIcon(SendTypes.Bulk);
        break;
      case SendTypes.Bulk2:
        classList += this.getColor(SendTypes.Bulk2) + " dark:!tw-text-" + this.getColor(SendTypes.Bulk2) + " " +  this.getIcon(SendTypes.Bulk2);
        break;
      case SendTypes.Club:
        classList += this.getColor(SendTypes.Club) + " dark:!tw-text-" + this.getColor(SendTypes.Club) + " " +  this.getIcon(SendTypes.Club);
        break;
      case SendTypes.Dynamic:
        classList += this.getColor(SendTypes.Dynamic) + " dark:!tw-text-" + this.getColor(SendTypes.Dynamic) + " " +  this.getIcon(SendTypes.Dynamic);
        break;
      case SendTypes.OTP:
        classList += this.getColor(SendTypes.OTP) + " dark:!tw-text-" + this.getColor(SendTypes.OTP) + " " +  this.getIcon(SendTypes.OTP);
        break;
      case SendTypes.P2P:
        classList += this.getColor(SendTypes.P2P) + " dark:!tw-text-" + this.getColor(SendTypes.P2P) + " " +  this.getIcon(SendTypes.P2P);
        break;
      case SendTypes.Phonebook:
        classList += this.getColor(SendTypes.Phonebook) + " dark:!tw-text-" + this.getColor(SendTypes.Phonebook) + " " +  this.getIcon(SendTypes.Phonebook);
        break;
      case SendTypes.Single:
        classList += this.getColor(SendTypes.Single) + " dark:!tw-text-" + this.getColor(SendTypes.Single) + " " +  this.getIcon(SendTypes.Single);
        break;
      case SendTypes.Smart:
        classList += this.getColor(SendTypes.Smart) + " dark:!tw-text-" + this.getColor(SendTypes.Smart) + " " +  this.getIcon(SendTypes.Smart);
        break;
      default:
        break;
    }
    return classList;
  }


  getIcon(sendType:SendTypes):string{
    return SendTypesUi.find(a => a.type == sendType).icon;
  }

  getColor(sendType:SendTypes):string{
    return SendTypesUi.find(a => a.type == sendType).tailwindColor;
  }


}

